import 'core-js/actual/object';
// @ts-ignore
import ClipboardJS from 'clipboard';

import {
    DeepLinkType, downloadUrls, eventCategory,
    getActivityConfig,
    getCurrentUrl,
    getPandoraData,
    isFacebook,
    isInstagram, isQQ,
    isWeChat,
    jumpDeepLink,
    registerDeeplinkButton,
} from './lib/utils';
import { getCurrentLanguage } from './lib/i18n';
import './index';

const CONST_DATA = {
    PANDORA_SHARE_KEY: 'inviteInfo',// 潘多拉分享数据的参数
};

/**
 * 获取潘多拉数据
 */
const pandoraData = getPandoraData<pandoraDataType>(CONST_DATA.PANDORA_SHARE_KEY, {
    module: 'CoinPush',
    appId: '2247',
    userName: '',
    code: '',
    playerHeadUrl: '',
});

console.log('pandoraData===>', pandoraData);
/**
 * 页面结束
 */
function updatePageEnd() {
    app.is_act_end = true;
}

/**
 * 页面初始话操作
 */
function initPage() {
    // 进行自动跳转潘多拉
    // jumpDeepLink({
    //     type:DeepLinkType.GOTO_PANDORA,pandoraData:jumpPandoraData
    // },()=>{
    //     gtag('event', 'deeplink_auto_success', { event_category: eventCategory, event_label: 'deeplink_auto_success' })
    // },()=>{
    //     gtag('event', 'deeplink_auto_fail', { event_category: eventCategory, event_label: 'deeplink_auto_fail' })
    // })
}

function onError(err: ErrorEvent) {
    console.error('Uncaught error:', err.error || err.message || err, err);
}

// 全局未捕获错误处理
window.addEventListener('error', onError);

let jumpPandoraData: pandoraDataType;
(async function() {
    // 从链接中获取语言，如果无法获取则尝试从系统语言中获取
    app.invite_code = pandoraData.code;
    app.userName = pandoraData.userName
    
    let lang = getCurrentLanguage(language_data, 'lang', 'langStr') || 'en';
    app.switchLanguage(lang);
    jumpPandoraData = { ...pandoraData };
    jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
    registerDeeplinkButton('.jump_game', jumpPandoraData, () => {
        console.log('成功跳转~');
    }, () => {
        console.log('失败跳转~');
        if (isFacebook() || isInstagram() || isWeChat() || isQQ()) {
            if(isWeChat() || isQQ() || isFacebook() || isInstagram()){
                app.tip_browser = 'top';
            // }else if( isInstagram()){
            //     app.tip_browser = 'bottom'
            }else {
                app.tip_browser = "center"
            }
            return false;
        }
    });
    
    // 复制链接
    new ClipboardJS('.btn-copy', {
        text() {
            const content = getCurrentUrl();
            console.log('[Act] 触发复制事件~');
            return content || '';
        },
    });
    
    await getActivityConfig('a20240520invite', {
        instanceid: 3000644,
    }, (data) => {
        console.log('拉取配置成功~==>', data);
        const { now, iActivityEndTime } = data;
        if (now >= iActivityEndTime) {
            // 活动结束
            updatePageEnd();
        } else {
            initPage();
        }
    }, (error) => {
        console.error('拉取配置失败~', error);
        initPage();
    });
})();
